import React from 'react'

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null, errorInfo: null }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true }
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo)
    this.setState({
      error: error,
      errorInfo: errorInfo
    })
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          padding: '20px',
          margin: '20px',
          border: '2px solid #dc3545',
          borderRadius: '8px',
          background: '#f8d7da',
          color: '#721c24'
        }}>
          <h2>⚠️ エラーが発生しました</h2>
          <p>アプリケーションでエラーが発生しました。下記の情報を確認してください。</p>
          
          <details style={{ marginTop: '10px' }}>
            <summary style={{ cursor: 'pointer', fontWeight: 'bold' }}>
              エラー詳細を表示
            </summary>
            <div style={{ 
              marginTop: '10px', 
              padding: '10px', 
              background: '#ffffff', 
              border: '1px solid #ccc',
              borderRadius: '4px',
              fontFamily: 'monospace',
              fontSize: '12px',
              whiteSpace: 'pre-wrap'
            }}>
              <strong>エラー:</strong><br/>
              {this.state.error && this.state.error.toString()}
              <br/><br/>
              <strong>スタックトレース:</strong><br/>
              {this.state.errorInfo?.componentStack || 'スタックトレース情報がありません'}
            </div>
          </details>
          
          <button 
            onClick={() => window.location.reload()} 
            style={{
              marginTop: '15px',
              padding: '10px 20px',
              background: '#007bff',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            🔄 ページを再読み込み
          </button>
        </div>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary